import { CarouselItemId } from '@homex/se-widget-flow-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components/macro';

import {
  setCurrentCarouselItem,
  setServiceCodeId,
  setServiceType,
} from 'actions';
import { CarouselContinueButton } from 'components/CarouselContinueButton';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { CarouselReduxReducer, IState, ServiceType } from 'typings';

import { Bottom } from './styles';

const CAROUSEL_FLOW_TRANSITION_DELAY = 500;

export const CarouselItemSelectServiceTypeBottom = () => {
  const dispatch = useThunkDispatch();
  const { serviceTypeRadioValue } = useSelector((state: IState) => ({
    serviceTypeRadioValue: state.userInput.serviceTypeRadioValue,
  }));
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();

  const handleServiceTypeChange = (
    destinationItemId: CarouselItemId,
    serviceType: ServiceType,
    transitionDuration: string,
  ): Promise<void> => {
    const parsedTransitionDuration = parseInt(transitionDuration, 10);
    const renderDelay = isNaN(parsedTransitionDuration)
      ? CAROUSEL_FLOW_TRANSITION_DELAY
      : parsedTransitionDuration + 250;

    return new Promise<void>((resolve) => {
      // We delay before setting the serviceType and doing any work in order to
      // give the loading indicator time to animate into its "isLoading" state.
      setTimeout(() => {
        dispatch(setServiceCodeId(undefined));
        dispatch(setServiceType(serviceType));

        dispatch(
          setCurrentCarouselItem(
            CarouselReduxReducer.SERVICE,
            destinationItemId,
          ),
        );

        resolve();
      }, renderDelay);
    });
  };

  const handleContinueClick = async () => {
    if (serviceTypeRadioValue) {
      setIsLoading(true);

      let nextCarouselItemId: CarouselItemId | undefined;

      switch (serviceTypeRadioValue) {
        case ServiceType.SALES:
          nextCarouselItemId = CarouselItemId.ContactInfo;

          break;
        case ServiceType.REPAIR:
          nextCarouselItemId = CarouselItemId.IssueSpecifier;

          break;
        case ServiceType.MAINTENANCE:
          // TODO
          break;
        default:
          // Do nothing
          break;
      }

      const destinationItemId = nextCarouselItemId;

      destinationItemId &&
        (await handleServiceTypeChange(
          destinationItemId,
          serviceTypeRadioValue,
          theme.transitionDurationPrimary,
        ));

      setIsLoading(false);
    }
  };

  return (
    <Bottom>
      <CarouselContinueButton
        isDisabled={!serviceTypeRadioValue}
        isLoading={isLoading}
        onClick={handleContinueClick}
      />
    </Bottom>
  );
};
